import {ValgtAvgiver} from '../avgiver';
import {bestemMiljo} from "../utils";

const VALGT_AVGIVER_URL = `${bestemBaseUrl()}/api/v1/kort/VALGT-AVGIVER`;

export function lagre(avgiver: ValgtAvgiver): Promise<ValgtAvgiver> {
    return fetch(VALGT_AVGIVER_URL,
        {
            headers : {
                'X-SELVBETJENING-XSRF-TOKEN' : hentXSRFToken(),
                'Content-type' : 'application/json;charset=UTF-8'
            },
            method: 'post',
            body: JSON.stringify(avgiver),
            credentials: "include",
        }
    ).then(res => {
        if (!res.ok)
            throw "Avgiver ikke lagret";
        return avgiver;
    });
}

export function hent() : Promise<ValgtAvgiver>  {
    return fetch(VALGT_AVGIVER_URL,
        {
            method: 'get',
            credentials: 'include',
        }
    ).then(res => {
        if (!res.ok) {
            // Etter fjerning av skallsikring så må vi håndtere utgåtte SVV-tokens.
            // Sjekker om reponsen fra backend har status 401 og inneholder headeren X-LOGINPAGE.
            // Hvis dette er tilfellet så redirecter vi til URL som finnes i headeren.
            if (res.status === 401) {
                const loginpageUrl = res.headers.get("x-loginpage");
                const goto =
                    loginpageUrl != null && loginpageUrl.includes("?")
                        ? "&goto="
                        : "?goto=";
                if (loginpageUrl) {
                    window.location.href = loginpageUrl + goto + encodeURIComponent(window.location.href);
                }
            }
            throw "avgiver ikke hentet";
        }
        return res.json();
    }).then(json => json.data);
}

function hentXSRFToken() : string{
	const tokens = document.cookie.split(';').filter((item) => item.indexOf('SELVBETJENING-XSRF-TOKEN') !== -1);
	return tokens.length > 0 ? tokens[0].split("=")[1] : null;
}

function bestemBaseUrl() {
    switch(bestemMiljo()) {
        case "stm":
            return "https://dinside-mellomlagring.utv.atlas.vegvesen.no";
        case "atm":
            return "https://dinside-mellomlagring.test.atlas.vegvesen.no";
        case "prod":
            return "https://dinside-mellomlagring.atlas.vegvesen.no";
    }
}